<dynamic-form-v2
  *ngIf="!isLoading"
  entityType="seasonal-prizes"
  [formName]="title"
  [(record)]="seasonalPrizesRecord"
  [fields]="fields"
  [viewRoute]="viewRoute"
  [rowData]="rowData"
>
</dynamic-form-v2>